'use client';

import type {
  QuoteRequest,
  QuoteSubmission,
} from '@/util/types/serverTypeCollection/repairList';
import QuoteRequestEntryRow from './QuoteRequestEntryRow';
import QuoteSubmissionEntryRow from './QuoteSubmissionEntryRow';
import { buildUnifiedQuoteEntries } from './quoteEntryUtils';

type RepairCompanySummary = {
  _id: string;
  name: string;
  logo?: string;
};

export type RepairListQuoteEntryListProps = {
  quoteSubmissions?: QuoteSubmission[];
  quoteRequests?: QuoteRequest[];
  repairListId: string;
  reportId?: string;
  repairCompanies?: RepairCompanySummary[];
  companyColor?: string;
  canViewQuoteDetails?: boolean;
  buildReportUrl?: (reportId: string) => string;
  buildRepairListViewUrl: (repairListId: string, itemIds: string[]) => string;
  className?: string;
  menuPortalContainer?: Element;
};

export default function RepairListQuoteEntryList({
  quoteSubmissions = [],
  quoteRequests = [],
  repairListId,
  reportId,
  repairCompanies = [],
  companyColor,
  canViewQuoteDetails = false,
  buildReportUrl,
  buildRepairListViewUrl,
  className,
  menuPortalContainer,
}: RepairListQuoteEntryListProps) {
  const quoteEntries = buildUnifiedQuoteEntries({ quoteRequests, quoteSubmissions });

  if (quoteEntries.length === 0) return null;

  return (
    <div
      className={`divide-y divide-gray-200 rounded-lg border bg-white ${className || ''}`.trim()}
    >
      {quoteEntries.map((entry) => {
        if (entry.type === 'request') {
          const quote = entry.quote;
          const repairCompany = repairCompanies.find(
            (company) => company._id === quote._repairCompanyId,
          );

          return (
            <QuoteRequestEntryRow
              key={entry.id}
              quote={quote}
              repairCompany={repairCompany}
              repairListId={repairListId}
              reportId={reportId}
              companyColor={companyColor}
              canViewQuoteDetails={canViewQuoteDetails}
              buildReportUrl={buildReportUrl}
              buildRepairListViewUrl={buildRepairListViewUrl}
              menuPortalContainer={menuPortalContainer}
            />
          );
        }

        return (
          <QuoteSubmissionEntryRow
            key={entry.id}
            submission={entry.submission}
            repairListId={repairListId}
            buildRepairListViewUrl={buildRepairListViewUrl}
            menuPortalContainer={menuPortalContainer}
          />
        );
      })}
    </div>
  );
}
